import { useState } from "react";
import { IoIosClose } from "react-icons/io";
import "./TitleAndImageForm.scss";
import { updateContactHome } from "../../../api/webData.api";

const ContactEditForm = ({
  setOpenEditContactForm,
  webData,
  setWebData,
  setHideContent,
}) => {
  const [directions, setDirections] = useState(
    webData.talkWithUs.directions || [],
  );
  const [phones, setPhones] = useState(webData.talkWithUs.phones || []);

  const [districts, setDistricts] = useState(
    Array.isArray(webData.talkWithUs.directionsDistrict)
      ? webData.talkWithUs.directionsDistrict
      : webData.talkWithUs.directionsDistrict
        ? [webData.talkWithUs.directionsDistrict]
        : [],
  );

  const [dirPhones, setDirPhones] = useState(
    Array.isArray(webData.talkWithUs.directionsPhone)
      ? webData.talkWithUs.directionsPhone
      : webData.talkWithUs.directionsPhone
        ? [webData.talkWithUs.directionsPhone]
        : [],
  );

  const [mapsUrls, setMapsUrls] = useState(
    Array.isArray(webData.talkWithUs.directionsMapsUrl)
      ? webData.talkWithUs.directionsMapsUrl
      : webData.talkWithUs.directionsMapsUrl
        ? [webData.talkWithUs.directionsMapsUrl]
        : [],
  );

  const [files, setFiles] = useState([]);

  const SubmitForm = async (e) => {
    e.preventDefault();
    const dataForm = new FormData();

    const appendArray = (name, array) => {
      array
        .filter((item) => item !== "")
        .forEach((value) => dataForm.append(name, value));
    };

    appendArray("directions", directions);
    appendArray("phones", phones);
    appendArray("directionsDistrict", districts);
    appendArray("directionsPhone", dirPhones);
    appendArray("directionsMapsUrl", mapsUrls);

    dataForm.append("titleHome", e.target.talkTitleHome?.value || "");
    dataForm.append("titleContact", e.target.talkTitleContact.value);
    dataForm.append(
      "descriptionContact",
      e.target.talkDescriptionContact.value,
    );
    dataForm.append("email", e.target.talkEmail?.value || "");
    dataForm.append("contactButton", e.target.talkContactButton.value);

    if (files[0]) dataForm.append("contactImage", files[0]);

    const uploadContactHome = await updateContactHome(dataForm, webData._id);

    if (Object.keys(uploadContactHome).includes("_id")) {
      // Actualizamos el objeto local con la respuesta del servidor
      const updatedTalk = uploadContactHome.talkWithUs;
      webData.talkWithUs = { ...webData.talkWithUs, ...updatedTalk };

      setOpenEditContactForm(false);
      setHideContent(false);
    }
  };

  const handleUploadPortraidImage = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    setFiles([file]);
  };

  return (
    <form onSubmit={SubmitForm} className="CatalogNewForm">
      <div className="CatalogNewForm__title">
        <h1>Editar Contacto</h1>
        <IoIosClose
          className="CatalogNewForm__title__close"
          onClick={() => {
            setOpenEditContactForm(false);
            setHideContent(false);
          }}
        />
      </div>

      <div className="CatalogNewForm__item">
        <label htmlFor="talkTitleContact">Título contacto</label>
        <input
          type="text"
          name="talkTitleContact"
          id="talkTitleContact"
          defaultValue={webData.talkWithUs.titleContact}
        />
      </div>

      <div className="CatalogNewForm__item">
        <label htmlFor="talkDescriptionContact">Descripción contacto</label>
        <textarea
          name="talkDescriptionContact"
          id="talkDescriptionContact"
          rows="4"
          defaultValue={webData.talkWithUs.descriptionContact}
        />
      </div>

      <div className="CatalogNewForm__item">
        <label htmlFor="portraidImage">Imagen contacto</label>
        <input
          type="file"
          name="portraidImage"
          id="portraidImage"
          accept="image/png, image/jpeg, image/jpg"
          onChange={handleUploadPortraidImage}
        />
      </div>

      {/* --- SECCIÓN DINÁMICA: DIRECCIONES --- */}
      <div className="CatalogNewForm__item">
        <label>
          Direcciones{" "}
          <span
            onClick={() => setDirections([...directions, ""])}
            style={{ cursor: "pointer" }}
          >
            +
          </span>
        </label>
        {directions.map((direction, i) => (
          <input
            type="text"
            key={`dir-${i}`}
            defaultValue={direction}
            onChange={(e) => {
              const newArr = [...directions];
              newArr[i] = e.target.value;
              setDirections(newArr);
            }}
          />
        ))}
      </div>

      {/* --- SECCIÓN DINÁMICA: DISTRITOS --- */}
      <div className="CatalogNewForm__item">
        <label>
          Distritos / Zonas{" "}
          <span
            onClick={() => setDistricts([...districts, ""])}
            style={{ cursor: "pointer" }}
          >
            +
          </span>
        </label>
        {districts.map((dist, i) => (
          <input
            type="text"
            key={`dist-${i}`}
            defaultValue={dist}
            onChange={(e) => {
              const newArr = [...districts];
              newArr[i] = e.target.value;
              setDistricts(newArr);
            }}
          />
        ))}
      </div>

      {/* --- SECCIÓN DINÁMICA: TELÉFONOS OFICINA --- */}
      <div className="CatalogNewForm__item">
        <label>
          Teléfonos Oficina{" "}
          <span
            onClick={() => setDirPhones([...dirPhones, ""])}
            style={{ cursor: "pointer" }}
          >
            +
          </span>
        </label>
        {dirPhones.map((phone, i) => (
          <input
            type="text"
            key={`phone-${i}`}
            defaultValue={phone}
            onChange={(e) => {
              const newArr = [...dirPhones];
              newArr[i] = e.target.value;
              setDirPhones(newArr);
            }}
          />
        ))}
      </div>

      {/* --- SECCIÓN DINÁMICA: MAPS URL --- */}
      <div className="CatalogNewForm__item">
        <label>
          Links Google Maps{" "}
          <span
            onClick={() => setMapsUrls([...mapsUrls, ""])}
            style={{ cursor: "pointer" }}
          >
            +
          </span>
        </label>
        {mapsUrls.map((url, i) => (
          <input
            type="text"
            key={`maps-${i}`}
            defaultValue={url}
            onChange={(e) => {
              const newArr = [...mapsUrls];
              newArr[i] = e.target.value;
              setMapsUrls(newArr);
            }}
          />
        ))}
      </div>

      <div className="CatalogNewForm__item">
        <label htmlFor="talkContactButton">Texto botón</label>
        <input
          type="text"
          name="talkContactButton"
          id="talkContactButton"
          defaultValue={webData.talkWithUs.contactButton}
        />
      </div>

      <div className="buttons-container">
        <button
          type="button"
          className="buttons-container-button"
          onClick={() => {
            setOpenEditContactForm(false);
            setHideContent(false);
          }}
        >
          Cancelar
        </button>
        <button type="submit" className="buttons-container-button">
          Editar
        </button>
      </div>
    </form>
  );
};

export default ContactEditForm;
